import React from 'react';

const DashboardPage = () => {
  return <h2>Dashboard</h2>;
};

export default DashboardPage;
